import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as heartbeatActions from './heartbeat.actions';

const pulseRate = process.env.PULSE_RATE;

export class HeartbeatComponent extends Component {
  constructor() {
    super();
    this.state ={
      interval: null
    }
  }

  scheduleHeartbeat() {
    var interval = setInterval(() => this.handleHeartbeat(), pulseRate);
    this.setState({
      interval
    });
  }

  handleHeartbeat() {
    const { auth, heartbeatActions } = this.props;
    const { isAuthenticated } = auth;
    if(isAuthenticated) {
      heartbeatActions.sendHeartbeat();
    }
  }

  componentDidMount() {
    const { auth } = this.props;
    const { isAuthenticated } = auth;
    if(isAuthenticated) {
      this.scheduleHeartbeat();
    }
  }

  componentDidUpdate(prevProps) {
    const { auth : prevAuth } = prevProps;
    const { isAuthenticated : wasAuthenticated } = prevAuth;
    const { auth } = this.props;
    const { interval } = this.state;
    const { isAuthenticated } = auth;

    if(wasAuthenticated && !isAuthenticated) {
      clearInterval(interval);
    }
    else if(!wasAuthenticated && isAuthenticated) {
      this.scheduleHeartbeat();
    }
  }

  render() {
    return null;
  }
}

HeartbeatComponent.propTypes = {
};

const mapStateToProps = ({ heartbeat, auth }) => {
  return {
    heartbeat,
    auth,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    heartbeatActions: bindActionCreators(heartbeatActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeartbeatComponent);



// WEBPACK FOOTER //
// src/auth/heartbeat-system/heartbeat.component.js